export default {
    namespaced: true,
  
    state: {

        selectedUnit:null,
        selectedTicket:null

    },
  
    getters: {
        
        getSelectedUnit:(state)=>state.selectedUnit,
        getSelectedTicket:(state)=>state.selectedTicket    
    },
  
    mutations: {
  
    },
  
    actions: {
        
        setSelectedUnit({state},unit){ 
             
                state.selectedUnit=unit 
        },
        setSelectedTicket({state},ticketID){

            state.selectedTicket=ticketID
        }
  
    }
  }
  